import { FormControl, FormGroup } from "@angular/forms";
import { DeviceBase } from "./device-base";
import { PropertyMetadata } from "../../properties/property-types";
import { RegisterElement } from "../element-decorator";
import { ParkinglevelComponent } from "../../../details/parkinglevel.component";
import { Type } from "@angular/compiler";
import { ElementValidationResult, LevelDesignerElementBase } from "../element-base";

@RegisterElement()
export class Gateway extends DeviceBase {
    protected sizeInMeters: number = 1;
    public override TypeName: string = "Gateway";
    public override ParentType: string | null = "ParkingLevel"
    public override ParentFormGroupName: string | null = "GatewayConfigurations";

    constructor(formGroup: FormGroup) {
        super(formGroup, 'assets/icons/gateway.svg');
        this.layerIndex = 5;
        const idValue = formGroup.get('Id')?.value;
        if (idValue && typeof idValue !== 'number') {
            formGroup.get('Id')?.setValue(null);
        }
        if (!formGroup.contains('ChipId')) {
            formGroup.addControl('ChipId', new FormControl(null));
        }
    }

    public override clone(): Gateway {
        return new Gateway(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            ...super.getPropertyMetadata(),
            {
                formControlName: 'ChipId',
                displayName: 'Chip ID',
                inputType: { 
                    type: 'searchable-select',
                    url: '/hardware/gateways/available/searches',
                    idProperty: 'ChipId',
                    labelProperty: 'ChipId',
                    minSearchLength: 2
                },
                order: 5,
                category: 'Hardware',
                hideOnMultipleSelection: true,
            }
           
           
        ];
    }

    public override default(): Gateway {
        return this;
    }

    public override checkPropertiesValid(allElements: LevelDesignerElementBase[]): ElementValidationResult {
        const result = super.checkPropertiesValid(allElements);

        const chipId = this.formGroup.get('ChipId')?.value;
        if (chipId != null) {
            const duplicate = allElements.some(other =>
                other !== this &&
                other instanceof Gateway &&
                other.formGroup.get('ChipId')?.value === chipId
            );
            if (duplicate) {
                result.errors.push(`Chip ID ${chipId} is assigned to another Gateway on this level`);
            }
        }

        return result;
    }
} 